import { Component, Input } from '@angular/core';

export type SortDirection = 'asc' | 'desc' | null;
export interface SortState { key: string; direction: SortDirection; }

/** Cycles a column's sort direction: asc -> desc -> none -> asc. */
export function nextSortDirection(current: SortDirection): SortDirection {
  if (current === 'asc') { return 'desc'; }
  if (current === 'desc') { return null; }
  return 'asc';
}

export function ariaSort(direction: SortDirection): 'ascending' | 'descending' | null {
  if (direction === 'asc') { return 'ascending'; }
  if (direction === 'desc') { return 'descending'; }
  return null;
}

/**
 * Sort-direction indicator for a <payarc-table> column header. The host <th> owns [attr.aria-sort]
 * and sort state; the actual click target is a real <button> (a <th> isn't keyboard-focusable or
 * -operable on its own) carrying the .pa-th-sort class; this component just renders the chevrons.
 * <th [attr.aria-sort]="ariaSort(sort.key === 'amount' ? sort.direction : null)">
 *   <button type="button" class="pa-th-sort" (click)="onSort('amount')">
 *     Amount <payarc-sort-icon [direction]="sort.key === 'amount' ? sort.direction : null"></payarc-sort-icon>
 *   </button>
 * </th>
 */
@Component({
  selector: 'payarc-sort-icon',
  template: `
    <svg class="pa-sort-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path class="pa-sort-icon__arrow" [class.pa-sort-icon__arrow--active]="direction === 'asc'" d="M7 11l5-5 5 5" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path class="pa-sort-icon__arrow" [class.pa-sort-icon__arrow--active]="direction === 'desc'" d="M7 13l5 5 5-5" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`,
  styleUrls: ['./payarc-sort-icon.component.css'],
  standalone: false
})
export class PayarcSortIconComponent {
  @Input() direction: SortDirection = null;
}
